// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { TSendTimerRequest, TSendTimerModel, IMappers, TSendTimerResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ITimerResponse } from '../../entities/timer/TimerResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSendTimerModel(parameters: TSendTimerRequest): TSendTimerModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'browser-telemetry',
    pathApi: '/v1/send-timer/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISendTimerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSendTimerRequest;
}

export async function fetchSendTimer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISendTimerOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSendTimerResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSendTimerModel(parameters),
    config,
  )) as FetchResponse<TSendTimerResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ITimerResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSendTimerResponse>;
}
